export interface IReferralMember {
  id: string;
  memberEmail: string;
  referralTokenId: string;
  status: ReferralMemberEnum;
  creditsEarned: number;
  updatedAt: string;
  createdAt: string;
}

export enum ReferralMemberEnum {
  "Completed",
  "InProgress",
}
